$(document).ready(function () {
    $('.mfp-iframe').each(function () {
        $(this).magnificPopup({type: 'iframe'});
    });

    $('.SliderBigMagnificPopup').each(function () {
        $(this).magnificPopup({
            delegate: 'a',
            type: 'image',
            tLoading: 'Loading image...',
            mainClass: 'mfp-img-mobile',
            downloadMarkup: '<a id="sb-nav-download" title="%title%" target="_blank"><i class="fa-lupe u-brandColor-quinery"></i></a>',
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
            },
            image: {
                tError: 'The image could not be loaded.',
                titleSrc: function (item) {
                    return item.el.attr('title');
                }
            }
        });
    });

    $('.presseSlider ul').each(function () {
        $(this).magnificPopup({
            delegate: 'a',
            type: 'image',
            tLoading: 'Loading image...',
            mainClass: 'mfp-img-mobile',
            downloadMarkup: '<a id="sb-nav-download" title="%title%" target="_blank"><i class="fa-lupe u-brandColor-quinery"></i></a>',
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
            },
            image: {
                tError: 'The image could not be loaded.',
                titleSrc: function (item) {
                    return item.el.attr('title');
                }
            }
        });
    });

    $('a[data-download]').each(function () {
        $(this).magnificPopup({
            type: 'image',
            tLoading: 'Loading image...',
            mainClass: 'mfp-img-mobile',
            downloadMarkup: '<a id="sb-nav-download" title="%title%" target="_blank"><i class="fa-lupe u-brandColor-quinery"></i></a>',
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
            },
            image: {
                tError: 'The image could not be loaded.',
                titleSrc: function (item) {
                    return item.el.attr('title');
                }
            }
        });
    });
});
